import { SEOHead } from "../components/SEOHead";

export function PrivacyPolicy() {
  return (
    <div className="max-w-3xl mx-auto px-4 pb-16">
      <SEOHead
        title="Политика конфиденциальности | Quantile Camp"
        description="Политика конфиденциальности платформы Quantile Camp — обработка персональных данных пользователей."
        url="https://www.quantilecamp.ru/privacy"
        noindex={true}
      />
      <h1 className="text-3xl font-heading font-semibold text-neutral-text mb-2">
        Политика конфиденциальности
      </h1>
      <p className="text-sm text-neutral-text/50 font-body mb-8">
        Редакция от 15 марта 2025 г.
      </p>

      <div className="space-y-8 font-body text-neutral-text leading-relaxed">

        {/* 1 */}
        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">1. Общие положения</h2>
          <p>
            Настоящая Политика конфиденциальности (далее — «Политика») определяет порядок
            обработки персональных данных пользователей образовательного сервиса Quantile Camp
            (далее — «Сервис», «Оператор»).
          </p>
          <p className="mt-2">
            Оператором персональных данных является: <strong>[ОПЕРАТОР]</strong>.
          </p>
          <p className="mt-2">
            Политика разработана в соответствии с требованиями Федерального закона
            от 27.07.2006 № 152-ФЗ «О персональных данных». Используя Сервис, вы
            соглашаетесь с условиями настоящей Политики.
          </p>
        </section>

        {/* 2 */}
        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">2. Какие данные мы собираем</h2>
          <p className="mb-2">
            При авторизации через Telegram мы получаем следующие данные из вашего профиля
            Telegram (передаются Telegram при вашем явном согласии):
          </p>
          <ul className="list-disc list-inside space-y-1 text-sm pl-2">
            <li>Числовой идентификатор пользователя Telegram (Telegram ID)</li>
            <li>Имя и фамилия (если указаны в профиле)</li>
            <li>Имя пользователя / username (если указано)</li>
            <li>URL фотографии профиля (если установлена)</li>
          </ul>
          <p className="mt-3 mb-2">
            Дополнительно в браузере (localStorage) сохраняются:
          </p>
          <ul className="list-disc list-inside space-y-1 text-sm pl-2">
            <li>Временный токен авторизации (<code className="text-xs bg-neutral-light px-1 rounded">authToken</code>)</li>
            <li>Кеш недавних вопросов AI-чата (<code className="text-xs bg-neutral-light px-1 rounded">recentQuestions_*</code>)</li>
            <li>Идентификатор последнего открытого чата (<code className="text-xs bg-neutral-light px-1 rounded">chatLastOpened_*</code>)</li>
            <li>Факт прохождения онбординга (<code className="text-xs bg-neutral-light px-1 rounded">onboarding_*</code>)</li>
          </ul>
          <p className="mt-3 text-sm text-neutral-text/70">
            Мы <strong>не собираем</strong>: адрес электронной почты, номер телефона,
            платёжные данные, геолокацию.
          </p>
        </section>

        {/* 3 */}
        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">3. Цели обработки данных</h2>
          <ul className="list-disc list-inside space-y-1 pl-2">
            <li>Идентификация пользователя и обеспечение доступа к Сервису</li>
            <li>Сохранение и синхронизация прогресса обучения между устройствами</li>
            <li>Персонализация AI-тьютора (история диалогов)</li>
            <li>Направление новостей об обновлениях платформы (при наличии отдельного согласия)</li>
          </ul>
        </section>

        {/* 4 */}
        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">4. Правовые основания обработки</h2>
          <p>
            Обработка персональных данных осуществляется на основании:
          </p>
          <ul className="list-disc list-inside space-y-1 pl-2 mt-2">
            <li>
              Согласия субъекта персональных данных (ст. 6, ч. 1, п. 1 ФЗ-152) —
              подтверждается чекбоксом при авторизации
            </li>
            <li>
              Необходимости исполнения договора об оказании услуг (ст. 6, ч. 1, п. 5 ФЗ-152)
            </li>
          </ul>
        </section>

        {/* 5 */}
        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">5. Передача данных третьим лицам</h2>
          <p className="mb-3">
            Для обеспечения работы Сервиса ваши данные могут передаваться следующим лицам:
          </p>

          <h3 className="font-semibold mb-2">Telegram</h3>
          <p className="text-sm mb-4">
            Авторизация осуществляется через Telegram Bot API. При авторизации
            данные вашего профиля передаются от Telegram на серверы Сервиса.
            Политика конфиденциальности Telegram:{" "}
            <a
              href="https://telegram.org/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:underline"
            >
              telegram.org/privacy
            </a>
          </p>

          <h3 className="font-semibold mb-2">
            AI-провайдеры (трансграничная передача данных, ст. 12 ФЗ-152)
          </h3>
          <p className="text-sm mb-2">
            Запросы пользователей к AI-тьютору (текст диалога) передаются сторонним
            провайдерам искусственного интеллекта. Передача осуществляется на серверы,
            расположенные <strong>за пределами Российской Федерации</strong>:
          </p>
          <div className="overflow-x-auto">
            <table className="w-full text-sm border-collapse mt-2 mb-4">
              <thead>
                <tr className="bg-neutral-light">
                  <th className="text-left p-2 border border-neutral-border font-semibold">Провайдер</th>
                  <th className="text-left p-2 border border-neutral-border font-semibold">Страна</th>
                  <th className="text-left p-2 border border-neutral-border font-semibold">Назначение</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="p-2 border border-neutral-border">DeepSeek</td>
                  <td className="p-2 border border-neutral-border">КНР</td>
                  <td className="p-2 border border-neutral-border">Генерация ответов AI-тьютора</td>
                </tr>
                <tr className="bg-neutral-light/50">
                  <td className="p-2 border border-neutral-border">Google Gemini</td>
                  <td className="p-2 border border-neutral-border">США</td>
                  <td className="p-2 border border-neutral-border">Генерация ответов AI-тьютора</td>
                </tr>
                <tr>
                  <td className="p-2 border border-neutral-border">OpenAI</td>
                  <td className="p-2 border border-neutral-border">США</td>
                  <td className="p-2 border border-neutral-border">Генерация ответов AI-тьютора</td>
                </tr>
                <tr className="bg-neutral-light/50">
                  <td className="p-2 border border-neutral-border">Fireworks AI</td>
                  <td className="p-2 border border-neutral-border">США</td>
                  <td className="p-2 border border-neutral-border">Генерация ответов AI-тьютора</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p className="text-sm text-neutral-text/70">
            Нажимая чекбокс согласия при авторизации, вы даёте явное согласие на
            трансграничную передачу своих данных указанным провайдерам в соответствии
            со ст. 12 ФЗ-152.
          </p>
        </section>

        {/* 6 */}
        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">6. Хранение данных</h2>
          <ul className="list-disc list-inside space-y-1 pl-2">
            <li>
              Серверные данные хранятся в базе данных PostgreSQL на серверах,
              расположенных на территории Российской Федерации
            </li>
            <li>
              Данные в браузере (localStorage) хранятся локально на вашем устройстве
              до удаления вами или очистки браузера
            </li>
            <li>
              Срок хранения серверных персональных данных — 3 (три) года с момента
              последней активности пользователя, после чего данные удаляются
            </li>
          </ul>
        </section>

        {/* 7 */}
        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">7. Права субъекта персональных данных</h2>
          <p className="mb-2">
            В соответствии со ст. 14–21 ФЗ-152 вы имеете право:
          </p>
          <ul className="list-disc list-inside space-y-1 pl-2">
            <li>На получение информации о составе обрабатываемых персональных данных</li>
            <li>На исправление неточных или неполных персональных данных</li>
            <li>На удаление персональных данных (право на забвение)</li>
            <li>На отзыв согласия на обработку персональных данных</li>
            <li>На обжалование действий Оператора в Роскомнадзор</li>
          </ul>
          <p className="mt-3">
            Для реализации прав направьте запрос на адрес:{" "}
            <a
              href="mailto:[EMAIL]"
              className="text-primary hover:underline"
            >
              [EMAIL]
            </a>
          </p>
          <p className="mt-2 text-sm text-neutral-text/70">
            Срок ответа на запрос — 30 дней.
          </p>
        </section>

        {/* 8 */}
        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">8. Безопасность</h2>
          <p>
            Оператор принимает технические и организационные меры для защиты персональных
            данных от несанкционированного доступа, изменения, раскрытия или уничтожения,
            в том числе использует протокол HTTPS для передачи данных.
          </p>
        </section>

        {/* 9 */}
        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">9. Изменения Политики</h2>
          <p>
            Оператор вправе вносить изменения в настоящую Политику. Актуальная версия
            размещается на данной странице. Продолжение использования Сервиса после
            публикации изменений означает согласие с обновлённой Политикой.
          </p>
        </section>

        {/* 10 */}
        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">10. Контактные данные</h2>
          <p>
            По вопросам, связанным с обработкой персональных данных, обращайтесь:
          </p>
          <p className="mt-2">
            <strong>Оператор:</strong> [ОПЕРАТОР]<br />
            <strong>Email:</strong>{" "}
            <a href="mailto:[EMAIL]" className="text-primary hover:underline">
              [EMAIL]
            </a>
          </p>
        </section>

      </div>
    </div>
  );
}
